import { Component } from '@angular/core';
import { version } from './../../../environments/version';

@Component({
    selector: 'app-version',
    template: `
    <aside class="version-info text-muted py-1 px-3 mx-3">Version {{ version }}</aside>
  `,
    styles: [`
    @use 'variables' as *;

    .version-info {
      font-size: 9px;
      line-height: 12px;
      padding-top: 5px !important;
      cursor: default;
      @media (max-width: 1024px) {
        width: 65px;
        text-align: center;
      }
    }
  `],
    standalone: false
})
export class VersionComponent {
  version = version;
}
